<template>
	<v-card
		class="sgnl-pb-4"
		:variant="flatCard ? 'outlined' : 'flat'"
		:rounded="inEditor ? 't-sm b-lg' : 'lg'"
		data-test="sig-cloud-storage-file-list-dialog"
	>
		<v-card-title
			v-if="showTitle"
			class="sgnl-flex sgnl-align-center sgnl-py-12 sgnl-px-16"
			>Signaloid Cloud Storage
			<v-spacer />
			<!-- FIXME: enable file copy/move -->
			<!-- <TooltipButton
				:color="fileMoveMode?'warning': 'primary'"
				:elevation="fileMoveMode?'0':'2'"
				@click="toggleMoveMode"
				:outlined="true"
				:icon="true"
				btnClass="sgnl-mr-8"
				btnIcon=""
				tooltipText="Move/Copy Files"
			></TooltipButton> -->

			<v-btn
				icon
				variant="text"
				size="small"
				@click="closeDialog"
			>
				<Close16 />
			</v-btn>
		</v-card-title>
		<v-divider v-if="showTitle" />
		<v-card-text
			:style="`min-width: ${minWidth}; min-height: ${minHeight}`"
			class="sgnl-py-8 sgnl-px-0 file-list-body"
		>
			<transition name="fade">
				<LoadingCard
					v-if="loadingFiles"
					loadingText="Loading Files"
				/>
				<div v-else>
					<v-row
						no-gutters
						v-if="dataFileTree && dataFileTree.length > 0"
					>
						<v-col :cols="fileMoveMode ? '6' : '12'">
							<div
								v-if="fileMoveMode"
								class="sgnl-subtitle-medium sgnl-font-italic"
							>
								Source
							</div>
							<v-treeview
								v-model="fileListBuffer"
								v-model:items="dataFileTree"
								v-model:opened="sourceOpenTrees"
								v-model:activated="sourcePath"
								item-value="path"
								item-title="name"
								item-children="children"
								return-object
								transition
								density="compact"
								class="sgnl-paragraph-s-regular"
								:activatable="fileMoveMode"
								:selectable="selectForDownload"
								:open-on-click="$vuetify.display.mobile && !fileMoveMode"
							>
								<template v-slot:prepend="{ item, isOpen }">
									<template v-if="item.type == 'dir'">
										<FolderOpen16
											v-if="isOpen"
											class="sgnl-icon-color-secondary"
										/>
										<Folder16
											v-else
											class="sgnl-icon-color-secondary"
										/>
									</template>
									<component
										v-else
										:is="util.fileIcons(item.type)"
										class="sgnl-icon-color-secondary"
									/>
								</template>

								<template v-slot:append="{ item }">
									<TooltipButton
										v-if="!fileMoveMode && util.isTextFile(item.type)"
										:icon="true"
										@click="openFileInFileViewer(item)"
										tooltipText="View file"
										:loading="item.path == fileBeingOpened"
										:data-test="`view-file-button-${item.name}`"
									>
										<template #btnContent>
											<View16 />
										</template>
									</TooltipButton>
									<TooltipButton
										v-if="!fileMoveMode && item.type != 'dir'"
										:icon="true"
										@click="downloadFile(item)"
										:loading="item.path == fileBeingDownloaded"
										tooltipText="Download"
										:data-test="`download-file-button-${item.name}`"
									>
										<template #btnContent>
											<Download16 />
										</template>
									</TooltipButton>
									<CopyToClipboardButton
										v-if="!fileMoveMode"
										:valueToCopy="item.path"
										:valueName="item.type == 'dir' ? 'directory path' : 'file path'"
									/>
									<TooltipButton
										v-if="!fileMoveMode && item.type == 'dir'"
										:icon="true"
										@click="openUploadDialog(item)"
										tooltipText="Upload"
										:data-test="`upload-file-button-${item.name}`"
									>
										<template #btnContent>
											<CloudUpload16 />
										</template>
									</TooltipButton>
									<TooltipButton
										v-if="!fileMoveMode && item.type == 'dir'"
										:icon="true"
										@click="openCreateDirectoryDialog(item)"
										tooltipText="Create Directory"
										:data-test="`create-directory-button-${item.name}`"
									>
										<template #btnContent>
											<FolderAdd16 />
										</template>
									</TooltipButton>
									<TooltipButton
										v-if="!fileMoveMode"
										:icon="true"
										@click="openDeletePathDialog(item)"
										tooltipText="Delete"
										data-test="delete-file-button"
									>
										<template #btnContent>
											<TrashCan16 class="sgnl-icon-color-error" />
										</template>
									</TooltipButton>
									<!--FIXME: enable file rename
									<TooltipButton
										v-if="!fileMoveMode"
										:icon="true"
										@click="openEditPathDialog(item)"
										tooltipText="Rename"
									>
										<template #btnContent>
											<Edit16 />
										</template>
									</TooltipButton>-->
								</template>
							</v-treeview>
						</v-col>
						<template v-if="fileMoveMode">
							<v-col cols="auto">
								<PageLast16 class="sgnl-ml-neg-12" />
								<div class="sgnl-mt-12 sgnl-mr-8 vertical-divider" />
							</v-col>
							<v-col cols="5">
								<div class="sgnl-ml-12 sgnl-subtitle-medium sgnl-font-italic">Destination</div>
								<v-treeview
									v-model="fileListBuffer"
									v-model:items="dataFileTree"
									v-model:opened="destinationOpenTrees"
									v-model:activated="destinationPath"
									item-value="path"
									item-title="name"
									item-children="children"
									return-object
									transition
									density="compact"
									class="sgnl-paragraph-s-regular"
									activatable
								>
									<!-- :selectable="selectForDownload" -->
									<template v-slot:prepend="{ item, isOpen }">
										<template v-if="item.type == 'dir'">
											<FolderOpen16
												v-if="isOpen"
												class="sgnl-icon-color-secondary"
											/>
											<Folder16
												v-else
												class="sgnl-icon-color-secondary"
											/>
										</template>
										<component
											v-else
											:is="util.fileIcons(item.type)"
											class="sgnl-icon-color-secondary"
										/>
									</template>
								</v-treeview>
							</v-col>
						</template>
					</v-row>

					<v-alert
						v-else
						class="sgnl-flex sgnl-justify-center"
						variant="outlined"
						type="warning"
						density="compact"
						border="start"
					>
						No files found.
					</v-alert>
				</div>
			</transition>
		</v-card-text>

		<v-divider />
		<v-card-actions class="sgnl-flex sgnl-justify-start sgnl-px-16 sgnl-py-12 sgnl-gap-8">
			<template v-if="fileMoveMode">
				<v-btn
					variant="flat"
					color="primary"
					@click="copyFiles"
					:disabled="!validMove"
				>
					<Copy16 />
					<span>Copy</span>
				</v-btn>
				<v-btn
					variant="outlined"
					@click="moveFiles"
					:disabled="true"
				>
					<FolderMoveTo16 />
					<span>Move</span>
				</v-btn>
			</template>
			<template v-else>
				<v-btn
					variant="flat"
					color="primary"
					@click="openCreateDirectoryDialog()"
					data-test="create-directory-button"
				>
					<FolderAdd16 />
					<span>Create Directory</span>
				</v-btn>
				<v-btn
					variant="outlined"
					@click="openUploadDialog()"
					data-test="upload-file-button"
				>
					<CloudUpload16 />
					<span>Upload Files</span>
				</v-btn>
			</template>
		</v-card-actions>
		<SigCloudStorageFileDeleteDialog
			v-if="showDeleteConfirmDialog && deletePathData"
			:showDialog="showDeleteConfirmDialog"
			:deletePathData="deletePathData"
			@close-dialog="closeDeletePathDialog"
			@delete-successful="deleteSuccessfulCallback"
		/>
		<SigCloudStorageFileUploadDialog
			v-if="showUploadDialog"
			:showDialog="showUploadDialog"
			:initialUploadDestination="uploadDestinationPath"
			@close-dialog="closeUploadDialog"
		/>
		<EditValueDialog
			v-if="showEditPathDialog && editPathData"
			:title="editPathData.type == 'dir' ? 'Rename Directory' : 'Rename File'"
			:valueHint="editPathData.type == 'dir' ? 'Directory Name' : 'File Name'"
			:showDialog="showEditPathDialog"
			:value="editPathData.name"
			@update:showDialog="closeEditPathDialog"
			@update:value="updateFileName"
		/>
		<SigCloudStorageCreateDirectoryDialog
			v-if="showCreateDirectoryDialog"
			:showDialog="showCreateDirectoryDialog"
			@update:showDialog="closeCreateDirectoryDialog"
			:parentDir="createDirectoryData"
			@directory-created="directoryCreatedCallback"
		/>
		<FileViewer
			:showDialog="showFileViewer"
			@update:showDialog="closeFileViewer"
			:title="fileViewerTitle"
			:fileText="fileViewerFileText"
			@download-file-request="downloadFileRequestHandler"
		/>
	</v-card>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Close16 from "@carbon/icons-vue/es/close/16";
import CloudUpload16 from "@carbon/icons-vue/es/cloud--upload/16";
import PageLast16 from "@carbon/icons-vue/es/page--last/16";
import Copy16 from "@carbon/icons-vue/es/copy/16";
import Download16 from "@carbon/icons-vue/es/download/16";
import View16 from "@carbon/icons-vue/es/view/16";
import FolderAdd16 from "@carbon/icons-vue/es/folder--add/16";
import TrashCan16 from "@carbon/icons-vue/es/trash-can/16";
import Edit16 from "@carbon/icons-vue/es/edit/16";
import FolderMoveTo16 from "@carbon/icons-vue/es/folder--move-to/16";
import Folder16 from "@carbon/icons-vue/es/folder/16";
import FolderOpen16 from "@carbon/icons-vue/es/folder--open/16";

// Components
import LoadingCard from "@/components/LoadingCard.vue";
import SigCloudStorageFileDeleteDialog from "@/components/DataSources/SigCloudStorageFileDeleteDialog.vue";
import SigCloudStorageFileUploadDialog from "@/components/DataSources/SigCloudStorageFileUploadDialog.vue";
import { useUploadsStore } from "@/stores/uploads";
import SigCloudStorageCreateDirectoryDialog from "@/components/DataSources/SigCloudStorageCreateDirectoryDialog.vue";
import EditValueDialog from "@/components/DataSources/EditValueDialog.vue";
import FileViewer from "@/components/DataSources/FileViewer.vue";
import TooltipButton from "@/components/Common/TooltipButton.vue";
import CopyToClipboardButton from "@/components/Common/CopyToClipboardButton.vue";

// Utilities
import { sdk } from "@/js/sdk";
import { triggerBlobDownload } from "@/js/utilities";
import * as dsUtil from "@/components/DataSources/utilities";
import { monitoringCaptureError } from "@/plugins/monitoring";

// Libraries
import axios from "axios";

// Types
import { FileTree } from "@/types/general";
import type { FileItem } from "@signaloid/cloud-compute-engine-client";

type ComponentData = {
	dataFileList: undefined;
	dataFileTree: undefined | FileTree[];
	fileListBuffer: any[];
	sourceOpenTrees: any[];
	destinationOpenTrees: any[];
	sourcePath: FileTree[];
	destinationPath: FileTree[];
	loadingFiles: boolean;
	selectForDownload: boolean;
	fileMoveMode: boolean;
	showEditPathDialog: boolean;
	editPathData: undefined | FileTree;
	showDeleteConfirmDialog: boolean;
	deletePathData: undefined | FileTree;
	showUploadDialog: boolean;
	uploadDestinationPath: undefined | string;
	fileBeingDownloaded: undefined | string;
	showCreateDirectoryDialog: boolean;
	createDirectoryData: undefined | string;
	showFileViewer: boolean;
	fileBeingOpened: undefined | string;
	fileViewerTitle: string;
	fileViewerFilePath: string;
	fileViewerFileText: undefined | string;
};

export default defineComponent({
	name: "SigCloudStorageFileList",
	components: {
		LoadingCard,
		EditValueDialog,
		SigCloudStorageFileDeleteDialog,
		SigCloudStorageFileUploadDialog,
		SigCloudStorageCreateDirectoryDialog,
		TooltipButton,
		CopyToClipboardButton,
		FileViewer,
		Close16,
		PageLast16,
		CloudUpload16,
		Copy16,
		Download16,
		View16,
		FolderAdd16,
		TrashCan16,
		Edit16,
		FolderMoveTo16,
		Folder16,
		FolderOpen16,
	},
	props: {
		showDialog: { type: Boolean, default: false },
		showTitle: { type: Boolean, default: true },
		flatCard: { type: Boolean, default: false },
		minWidth: { type: String, default: "10px" },
		minHeight: { type: String, default: "50px" },
		inEditor: { type: Boolean, default: false },
	},
	emits: {
		"delete-successful": (itemType: string) => typeof itemType === "string",
		"directory-created": () => true,
		"update:showDialog": (value: boolean) => typeof value === "boolean",
	},
	data: (): ComponentData => ({
		dataFileList: undefined,
		dataFileTree: undefined,
		fileListBuffer: [],
		sourceOpenTrees: [],
		destinationOpenTrees: [],
		sourcePath: [],
		destinationPath: [],
		loadingFiles: false,
		selectForDownload: false,
		fileMoveMode: false,

		showEditPathDialog: false,
		editPathData: undefined,

		showDeleteConfirmDialog: false,
		deletePathData: undefined,

		showUploadDialog: false,
		uploadDestinationPath: undefined,
		fileBeingDownloaded: undefined,

		showCreateDirectoryDialog: false,
		createDirectoryData: undefined,

		showFileViewer: false,
		fileBeingOpened: undefined,
		fileViewerTitle: "",
		fileViewerFilePath: "",
		fileViewerFileText: undefined,
	}),
	setup() {
		const uploadsStore = useUploadsStore();
		return { util: dsUtil, uploadsStore };
	},
	watch: {
		"uploadsStore.completionTick"() {
			// silent: refresh without flashing the loading card over the tree.
			this.getUserFiles(true);
		},
	},
	computed: {
		validMove() {
			if (this.sourcePath[0].type && this.destinationPath[0].type) {
				if (
					(this.sourcePath[0].type == "dir" && this.destinationPath[0].type == "dir") ||
					(this.sourcePath[0].type != "dir" && this.destinationPath[0].type == "dir")
				) {
					return true;
				}
			}
			return false;
		},
	},
	methods: {
		closeDialog() {
			this.$emit("update:showDialog", false);
		},
		async getUserFiles(silent = false) {
			try {
				if (!silent) {
					this.loadingFiles = true;
				}

				const allPaths: string[] = [];
				let continueToken: string | null = null;

				do {
					const response = await sdk.files.list({ startKey: continueToken ?? undefined });
					const paths = response.items.map((item) => item.path);
					allPaths.push(...paths);

					continueToken = response.nextContinuationToken ?? null;
				} while (continueToken != null);

				const dataFiles = dsUtil.pathListToDirectoryTree(allPaths);

				this.dataFileTree = dataFiles;
			} catch (error) {
				monitoringCaptureError(error, "Fetch user files list in cloud storage");
			} finally {
				this.loadingFiles = false;
			}
		},
		validateMove() {
			// currently not used
			console.log(
				"src",
				JSON.stringify(this.sourcePath[0].path),
				"dst",
				JSON.stringify(this.destinationPath[0].path),
			);
		},
		async copyFiles() {
			// currently not used; no SDK equivalent for file copy yet
			this.validateMove();
		},
		async downloadFile(file: Pick<FileTree, "name" | "path">) {
			this.fileBeingDownloaded = file.path;
			try {
				const meta = await this.fetchFileMetadata(file.path);
				if (meta?.download_url) {
					const response = await axios.get(meta.download_url, { responseType: "blob" });
					triggerBlobDownload(new Blob([response.data]), file.name);
					this.$posthog?.capture("cloud_storage_file_downloaded");
				}
			} catch (error) {
				monitoringCaptureError(error, "Download files from user cloud storage");
			} finally {
				this.fileBeingDownloaded = undefined;
			}
		},
		async openFileInFileViewer(file: FileTree) {
			this.fileBeingOpened = file.path;
			try {
				const meta = await this.fetchFileMetadata(file.path);
				if (meta?.download_url) {
					const response = await axios.get(meta.download_url, { responseType: "blob" });
					this.fileViewerFileText = await new Blob([response.data]).text();
					this.fileViewerTitle = file.name;
					this.fileViewerFilePath = file.path;
					this.showFileViewer = true;
				}
			} catch (error) {
				monitoringCaptureError(error, "Open file from user cloud storage");
			} finally {
				this.fileBeingOpened = undefined;
			}
		},
		/*
		 *	Resolve a file's metadata + presigned download URL via the SDK.
		 *
		 *	`sdk.files.get(path, true)` should return a `FileItem` containing
		 *	`download_url`, but in the browser the SDK forces axios into
		 *	`responseType: "blob"`, so the JSON metadata arrives wrapped in a
		 *	Blob. Unwrap it back to JSON before returning so the caller can
		 *	use `download_url` directly.
		 */
		async fetchFileMetadata(path: string): Promise<FileItem | undefined> {
			const result = await sdk.files.get(path, true);
			if (result instanceof Blob) {
				return JSON.parse(await result.text()) as FileItem;
			}
			return result;
		},
		downloadFileRequestHandler() {
			const file = {
				path: this.fileViewerFilePath,
				name: this.fileViewerTitle,
			};
			this.downloadFile(file);
		},
		closeFileViewer() {
			this.showFileViewer = false;
			this.fileBeingOpened = undefined;
			this.fileViewerTitle = "";
			this.fileViewerFilePath = "";
			this.fileViewerFileText = undefined;
		},
		moveFiles() {
			// currently not used
			this.validateMove();
			// this.copyFiles()
			// this.deleteFile()

			// if (this.validMove) {
			// }
		},
		toggleMoveMode() {
			// currently not used
			this.fileMoveMode = !this.fileMoveMode;
			this.sourcePath = [];
			this.destinationPath = [];
		},
		openEditPathDialog(file: FileTree) {
			// currently not used
			this.showEditPathDialog = true;
			this.editPathData = file;
		},
		closeEditPathDialog() {
			this.showEditPathDialog = false;
			this.editPathData = undefined;
		},
		updateFileName() {
			this.getUserFiles();
			this.closeEditPathDialog();
		},

		openDeletePathDialog(file: FileTree) {
			this.showDeleteConfirmDialog = true;
			this.deletePathData = file;
		},
		closeDeletePathDialog() {
			this.showDeleteConfirmDialog = false;
			this.deletePathData = undefined;
		},
		deleteSuccessfulCallback(itemType: string) {
			this.$emit("delete-successful", itemType);
			this.getUserFiles();
		},
		openUploadDialog(item?: FileTree) {
			if (!item || item.type == "dir") {
				this.showUploadDialog = true;
				this.uploadDestinationPath = item?.path;
			} else {
				console.warn("Tried to open upload dialog with a file destination");
				this.showUploadDialog = false;
				this.uploadDestinationPath = undefined;
			}
		},
		closeUploadDialog() {
			this.showUploadDialog = false;
			this.uploadDestinationPath = undefined;
		},
		directoryCreatedCallback() {
			this.$emit("directory-created");
			this.getUserFiles();
		},
		openCreateDirectoryDialog(item?: FileTree) {
			this.showCreateDirectoryDialog = true;
			this.createDirectoryData = item?.path ? item.path : "";
		},
		closeCreateDirectoryDialog() {
			this.showCreateDirectoryDialog = false;
			this.createDirectoryData = undefined;
		},
	},
	mounted() {
		this.getUserFiles();
	},
});
</script>

<style scoped>
.file-list-body {
	max-width: 1000px;
}
.vertical-divider {
	border-left: 2px dotted var(--sgnl-default-secondary-border);
	height: 85%;
	position: relative;
	/* left: 50%;
	margin-left: -3px;
	top: 0; */
}
/* moving */

.fade-enter-active {
	transition: all 0.5s ease;
}
.fade-enter,
.fade-leave-to {
	/* transform: translateY(-10px); */
	opacity: 0;
}

.slide-left-enter-active {
	transition: all 0.2s ease;
}
.slide-left-leave-active {
	transition: all 0.2s ease;
}
.slide-left-enter,
.slide-left-leave-to {
	transform: translateX(-10px);
	opacity: 0;
}
</style>
